const PRODUCTION_API_URL = 'https://scheduleapp-api-792941155524.us-central1.run.app';

export function getApiBaseUrl() {
  const fromEnv = String(process.env.REACT_APP_API_URL || '')
    .trim()
    .replace(/\/+$/, '');
  if (fromEnv) return fromEnv;
  if (process.env.NODE_ENV === 'development') return 'http://localhost:8081';
  return PRODUCTION_API_URL;
}

export function isApiMeEnabled() {
  return true;
}

export function isAppointmentsApiEnabled() {
  return true;
}
